import createContext, { Action, DispatchAction } from "./createDataContext";
import { Notification } from "model/notificationsModel";
import { baseApi } from "api";

const NOTIFICATION_READ = "SET_NOTIFICATION_READ"
const SET_NOTIFICATION_LIST = "SET_NOTIFICATION_LIST"
const SET_ALL_NOTIFICATIONS_READ = "SET_ALL_NOTIFICATIONS_READ"
const SET_ALL_NOTIFICATIONS_READ_BY_ORG = "SET_ALL_NOTIFICATIONS_READ_BY_ORG"
const SET_ALL_NOTIFICATIONS_UNREAD_BY_ORG = "SET_ALL_NOTIFICATIONS_UNREAD_BY_ORG"

const INITIAL_STATE = {
    notificationList: [] as Notification[],
    toReadNumber: 0
};

const reducer = (state: typeof INITIAL_STATE, action: Action) => {
    switch (action.type) {
        case NOTIFICATION_READ: {
            const idNotification = action.payload
            const nuovaNotificationList = [...state.notificationList.map((not: Notification) => not.id === idNotification ? { ...not, readed: true } : not)]
            return { ...state, notificationList: nuovaNotificationList, toReadNumber: nuovaNotificationList.filter((n: Notification) => !n.readed).length };
        }
        case SET_NOTIFICATION_LIST: {
            return { ...state, notificationList: action.payload, toReadNumber: action.payload?.filter((n: Notification) => !n.readed).length || 0 };
        }
        case SET_ALL_NOTIFICATIONS_READ: {
            const nuovaNotificationList = state.notificationList.map((n: Notification) => ({ ...n, readed: true }));
            return { ...state, notificationList: nuovaNotificationList, toReadNumber: 0 };
        }
        case SET_ALL_NOTIFICATIONS_READ_BY_ORG: {
            const idorg = action.payload
            const nuovaNotificationList = state.notificationList.map((n: Notification) =>
                n.idorganization === idorg ? { ...n, readed: true } : n
            );
            return { ...state, notificationList: nuovaNotificationList, toReadNumber: nuovaNotificationList.filter((n: Notification) => !n.readed).length };
        }
        case SET_ALL_NOTIFICATIONS_UNREAD_BY_ORG: {
            const idorg = action.payload
            const nuovaNotificationList = state.notificationList.map((n: Notification) =>
                n.idorganization === idorg ? { ...n, readed: false } : n
            );
            return { ...state, notificationList: nuovaNotificationList, toReadNumber: nuovaNotificationList.filter((n: Notification) => !n.readed).length };
        }
        default: {
            return state;
        }
    }
};

const readNotification: DispatchAction<{ id: number }, void> =
    (dispatch) => async ({ id }) => {
        dispatch({ type: NOTIFICATION_READ, payload: id });
        try {
            await baseApi.put(`/notifications/${id}/read`);
        } catch { }
    };
const setNotificationList: DispatchAction<{ notifications: Notification[] }, void> =
    (dispatch) => ({ notifications }) => {
        dispatch({ type: SET_NOTIFICATION_LIST, payload: notifications });
    };
const readAllNotifications: DispatchAction<{ idorg: number }, void> =
    (dispatch) => async ({ idorg }) => {
        dispatch({ type: SET_ALL_NOTIFICATIONS_READ_BY_ORG, payload: idorg });
        try {
            await baseApi.put(`/notifications/organization/${idorg}/mark-all-read`);
        } catch { }
    };
const readAllNotificationsGlobal: DispatchAction<void, void> =
    (dispatch) => async () => {
        dispatch({ type: SET_ALL_NOTIFICATIONS_READ });
        try {
            await baseApi.put(`/notifications/mark-all-read`);
        } catch { }
    };
const unreadAllNotifications: DispatchAction<{ idorg: number }, void> =
    (dispatch) => async ({ idorg }) => {
        dispatch({ type: SET_ALL_NOTIFICATIONS_UNREAD_BY_ORG });
        try {
            await baseApi.put(`/notifications/organization/${idorg}/mark-all-unread`);
        } catch { }
    };
const actions = {
    readNotification,
    setNotificationList,
    readAllNotifications,
    readAllNotificationsGlobal,
    unreadAllNotifications
};

type ActionsType = typeof actions;
export type NotificationContextType = {
    state: typeof INITIAL_STATE;
    actions: {
        [Property in keyof ActionsType]: ReturnType<ActionsType[Property]>;
    };
};
export const { Context, Provider } = createContext<
    NotificationContextType,
    typeof INITIAL_STATE,
    typeof actions
>(reducer, actions, INITIAL_STATE);
